// Shared design tokens for the Financial module (P&L Entry + Full Ledger).
// Captures the palette/spacing/type values that already repeat across both
// screens' inline styles, so changing one of them is a one-line edit instead
// of a find-and-replace across two files. Not a CSS framework — screens keep
// using plain `style={}` objects, just built from these tokens.

export const colors = {
  textPrimary: '#0f172a',
  textSecondary: '#334155',
  textMuted: '#64748b',
  textFaint: '#94a3b8',

  success: '#16a34a',
  successDark: '#15803d',
  successBg: '#f0fdf4',
  successBorder: '#86efac',

  danger: '#dc2626',
  dangerDark: '#991b1b',
  dangerBg: '#fef2f2',
  dangerBg2: '#fee2e2',
  dangerBorder: '#fecaca',

  warningBg: '#fef9c3',
  warningBorder: '#fef08a',
  warningText: '#854d0e',
  warningTextMuted: '#a16207',

  primary: '#2563eb',
  primaryDark: '#1d4ed8',
  primaryBg: '#eff6ff',
  primaryBg2: '#dbeafe',
  primaryBorder: '#bfdbfe',

  border: '#e2e8f0',
  borderMuted: '#f1f5f9',
  surface: '#ffffff',
  surfaceMuted: '#f8fafc',
};

// 4px-based spacing scale: spacing(1) === '4px', spacing(4) === '16px'.
export const spacing = (n: number): string => `${n * 4}px`;

export const fontSize = {
  xs: '0.75rem',
  sm: '0.825rem',
  md: '0.875rem',
  lg: '1rem',
  xl: '1.25rem',
  xxl: '1.5rem',
};

export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
};

export const radius = {
  sm: 6,
  md: 8,
  lg: 10,
  xl: 12,
  pill: 20,
};
